import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Table = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).tables.border.color,
}));

export const MultilineDataRow = styled.td({
    padding: "0 0 10px !important",
    verticalAlign: "top",
});
